import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "apx:ui-mode";
const ModeContext = createContext({ mode: "beginner", beginner: true, setMode: () => {} });

// Beginner / Advanced is presentation only: Beginner adds explanations and folds advanced panels; nothing is removed.
export const ModeProvider = ({ children }) => {
  const { user } = useAuth();
  const [mode, setModeState] = useState(() => localStorage.getItem(KEY) || "beginner");

  useEffect(() => {
    if (user?.ui_mode && user.ui_mode !== mode) { setModeState(user.ui_mode); localStorage.setItem(KEY, user.ui_mode); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.ui_mode]);

  const setMode = useCallback((m) => {
    setModeState(m); localStorage.setItem(KEY, m);
    if (user) api.put("/auth/me/mode", { ui_mode: m }).catch((e) => console.warn("[apex] request failed:", e?.message || e));
  }, [user]);

  const value = useMemo(() => ({ mode, beginner: mode === "beginner", setMode }), [mode, setMode]);
  return <ModeContext.Provider value={value}>{children}</ModeContext.Provider>;
};

export const useMode = () => useContext(ModeContext);
